import React from "react";
import "./InfoIcon.css";
import RenderSvg from "../renderSvg/RenderSvg";

interface InfoIconProps {
  message: string;
  top?: boolean;
  bottom?: boolean;
}

export const InfoIcon: React.FC<InfoIconProps> = ({
  message,
  top,
  bottom,
}) => {
  return (
    <div className="info-icon-container">
      <div className="tooltip-container">
        <RenderSvg
          name="infoIconMSO"
        />
        <span className="tooltip-text" style={{
          top: top ? "-20px" : "auto",
          bottom: bottom ? "-40px" : "auto",
          left:"auto",
          right: "auto"
        }}>
          {message}</span>
      </div>
    </div>
  );
}
